export enum ContextGroundingEvent {
    ContactSalesClicked = 'ContextGrounding.ContactSalesClicked',
}
